var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import { Button } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
import { REPORTS_CONFIG } from "./reportsConfig";
import { usePermissions } from "../../hooks/usePermissions";
export var OutputsReportList = function (_a) {
    var selectedReport = _a.selectedReport, onSelectReport = _a.onSelectReport;
    var hasAnyRole = usePermissions().hasAnyRole;
    var visibleReports = REPORTS_CONFIG.filter(function (report) {
        return hasAnyRole(__spreadArray([], report.allowedRoles, true));
    });
    return (React.createElement(React.Fragment, null, visibleReports.map(function (report) { return (React.createElement(Button, { key: report.id, buttonStyle: selectedReport === report.key ? "primary" : "default", fullWidth: true, align: "start", onClick: function () { return onSelectReport(report.key); } },
        React.createElement(FormattedMessage, { id: report.translationKey }))); })));
};
